<template>
    <div :id="idName" :class="'row ' + className">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                default: "",
                type: String,
            },
            className: {
                default: "",
                type: String,
            },
            idName: {
                default: "",
                type: String,
            }
        }
    }
</script>